/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import type { ReactNode } from 'react';

import { css, jsx } from '@compiled/react';

import { token } from '@atlaskit/tokens';

const spacingWrapperContainerStyles = css({
	width: '100%',
	paddingInline: token('space.400'),
});

const spacingWrapperStyles = css({
	maxWidth: '1416px',
	flex: '1 0 100%',
	marginLeft: 'auto',
	marginRight: 'auto',
});

type SpacingWrapperProps = {
	children: ReactNode;
	className?: string;
};

export function SpacingWrapper({ children, className }: SpacingWrapperProps): JSX.Element {
	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
		<div css={spacingWrapperContainerStyles} className={className}>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop */}
			<div css={spacingWrapperStyles}>{children}</div>
		</div>
	);
}
